export default __webpack_public_path__ + "static/media/2.b85779e2.webp";